import { SortInput } from '@apeiron/common'
import { PlanetFilterInput, PlanetSortBy } from '@apeiron/planet'
import SaveFilter from '@src/components/share/filter/saveFilter/SaveFilter'
import { FavoriteType } from '@src/constants/favoriteFilter'
import { toGraphqlFilter } from '@src/util/apeiron/planetList'
import { FC, useCallback, useMemo } from 'react'

const PlanetSaveFilter: FC<Props> = (props: Props) => {
  const { className, filterOptions, sortInput, onFilterByFavorite } = props

  const filterInput = useMemo(
    () => toGraphqlFilter(filterOptions),
    [filterOptions]
  )

  const handleOnFilterByFavorite = useCallback(
    (filter: PlanetFilterInput, sort: SortInput<PlanetSortBy>) => {
      if (onFilterByFavorite) {
        onFilterByFavorite(filter, sort)
      }
    },
    [onFilterByFavorite]
  )

  return (
    <SaveFilter
      className={className}
      filterInput={filterInput}
      sortInput={sortInput}
      type={FavoriteType.Planet}
      onFilterByFavorite={handleOnFilterByFavorite}
    />
  )
}

export type Props = {
  className?: string
  filterOptions: PlanetFilterInput
  sortInput: SortInput<PlanetSortBy>
  onFilterByFavorite?: (
    filter: PlanetFilterInput,
    sorting: SortInput<PlanetSortBy>
  ) => void
}

export default PlanetSaveFilter
